<template>
  <v-dialog
    v-model="show"
    :persistent="options.persistent"
    :transition="transition"
    :max-width="options.maxWidth"
    min-width="640px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    class="search-dialog"
  >
    <v-card height="485px">

      <v-toolbar
        flat
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="cancelDialog"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Download</v-toolbar-title>
        <v-spacer></v-spacer>

      </v-toolbar>

      <v-card-text>
        <v-list v-if="this.options.forwardedImages">
          <v-list-tile
            row
            v-for="item in this.options.forwardedImages"
            :key="item._id"
            @click="download(item)"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{item.description}}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-avatar>
              <v-icon>file_download</v-icon>
            </v-list-tile-avatar>
          </v-list-tile>
        </v-list>
      </v-card-text>

      <v-spacer />

      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          depressed
          @click="_downloadBundle"
        >Download All</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
@import '../../../styles/form';
$color: #1565c0;

.building {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  color: white;
  margin-left: 30px;
}

.content {
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  color: #52535f;
  padding: 18px 15px;
  font-weight: bold;
}

.footer {
  border-top: 1px solid #e0e0e0;
}

.input {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  padding: 8px 16px;
  width: 100%;
  border-radius: 4px;
  font-size: 18px;
  // margin-top: 16px;
  background: white;
}

.outline {
  border: 1px solid #eeeeee;
}

.search-dialog {
  min-height: 640px;
  height: 100px;
}

.selected-title {
  font-size: 14px;
  font-weight: bold;
}

.dialog-height {
  min-height: 400px;
}
</style>

<script>
import DialogMixin from '@/core/mixins/DialogMixin'
import { mapState, mapActions } from 'vuex'

export default {
  mixins: [DialogMixin],
  computed: {
    ...mapState('auth', ['authToken'])
  },
  methods: {
    ...mapActions('file', ['downloadBundle']),
    onOpen() {
      console.log(this.options)
    },
    download(item) {
      window.open(item.downloadURL + '?alt=media&token=' + item.accessToken)
    },
    _downloadBundle() {
      let fileIds = []
      for (let file of this.options.forwardedImages) {
        fileIds.push(file._id)
      }
      this.downloadBundle(fileIds)
    },
    cancelDialog() {
      this.formInput = ''
      this.selectedAllergy = ''
      this.cancel()
    },
    convertToUnix(date) {
      if (date !== '') {
        const splitDate = date.toString().split('/')
        const formatDate =
          splitDate[0] + '.' + splitDate[1] + '.' + splitDate[2]
        // Format: '2012.08.10'
        return new Date(formatDate).getTime() / 1000
      }
    }
  },
  mounted() {
    this.$on('open', this.onOpen)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs/DownloadImagesDialog.vue